import { render, staticRenderFns } from "./TesterIndex.vue?vue&type=template&id=3f43312b"
import script from "./TesterIndex.vue?vue&type=script&lang=js"
export * from "./TesterIndex.vue?vue&type=script&lang=js"
import style0 from "./TesterIndex.vue?vue&type=style&index=0&id=3f43312b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports